import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.isLoggedIn();
    if (currentUser!) {
      // logged in so return true
      return true;
    }
    console.log('from auth guard', 'logging out.....');
    this.authService.logout();
    this.router.navigate(['/auth/login'], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }

  // check if user is logged in. Return true if logged in.
  private isLoggedIn(): boolean {
    const user = this.authService.currentUserValue;
    return !!user;
  }
}
